import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';

const Tips = ({ className, t }) => (
  <div className={className}>
    <p>{t('tips.title')}:</p>
    <ul>
      <li>
        <span className="checkIconWrapper">
          <Icon glyph="check" color="primary" size="16px" />
        </span>
        {t('tips.tip1')}
      </li>
      <li>
        <span className="checkIconWrapper">
          <Icon glyph="check" color="primary" size="16px" />
        </span>
        {t('tips.tip2')}
      </li>
    </ul>
  </div>
);

Tips.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

Tips.defaultProps = {
  className: '',
  t: (t) => t,
};

export default Tips;
